module.exports = __webpack_public_path__ + "bd7e6900a43fd9a089704dd2c4e89c9b.png";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img4-en.png
// module id = 247
// module chunks = 2